module.exports = __webpack_public_path__ + "media/images/common/img_itsumono_order-2f56fa08a17c62681faded8b7ddb7db9.png";